import { Component, Input, OnDestroy, OnInit, NgZone } from '@angular/core';
import { ObjectDto } from '../../models/object-dto';
import { ImageDto } from '../../models/image-dto';
import { ObjectRowsDto } from 'src/app/models/object-rows-dto';
import { ObjectService } from 'src/app/services/object-service';
import { ApiService } from 'src/app/services/api.service';
import { RoutingService } from 'src/app/services/routing.service';
import { EntityType } from 'src/app/enums/entity-type.enum';
import { Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { take } from 'lodash';
import { ScreenDimensionsService } from 'src/app/services/screen-dimensions.service';
import { MultiLangStrDto } from 'src/app/models/multi-lang-str-dto';
import { LanguageService } from 'src/app/services/language.service';
import { MenuItemsService } from 'src/app/services/menu-items.service';
import { GaService } from 'src/app/services/ga.service';

@Component({
  selector: 'object',
  templateUrl: './object.component.html',
  styleUrls: ['./object.component.scss'],
})
export class ObjectComponent implements OnInit, OnDestroy {
  private entityDetailsSubscription?: Subscription;
  closeClicked: Subject<void> = new Subject<void>();
  entityId: number = -1;
  entityIdHachraza:string='';
  images: any | ImageDto[] | undefined = [];
  thumbnails:  any | ImageDto[] | undefined = [];
  objectLoading: boolean = false;
  objectDetails: ObjectDto | null = null;
  rows: ObjectRowsDto | null = null;
  rowsValues: any[] = [];
  isSmallScreen = false;
  protected readonly Array = Array;
  licencesValue!: MultiLangStrDto;
  currentLanguage$!: Observable<string>;

  constructor(
    private routingService: RoutingService,
    private objectService: ObjectService,
    private apiService: ApiService,
    private screenDimensionsService: ScreenDimensionsService,
    private languageService: LanguageService,
    public menuItemsService: MenuItemsService,
    private gaService: GaService,
    private ngZone: NgZone
  ) { }

  ngOnInit(): void {
    this.currentLanguage$ = this.languageService.currentLanguage$;
    this.screenDimensionsService.isSmallScreen$.subscribe(isSmallScreen => {
      this.isSmallScreen = isSmallScreen
    });
    this.entityDetailsSubscription = this.routingService.entityDetails$.subscribe(entityDetails => {
      this.ngZone.run(() => {
        const { id, type } = entityDetails;
        if (!!id && type === EntityType.OBJECT) {
          this.entityId = id;
          this.getObjectDetails();
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.entityDetailsSubscription?.unsubscribe();
  }

  getObjectDetails() {
    this.objectLoading = true;
    this.apiService
      .getObjectDetails(this.entityId)
      .pipe(takeUntil(this.closeClicked))
      .subscribe({
        next: (res: ObjectDto) => {
          this.objectDetails = res;
          this.entityIdHachraza=res.entityIdHachraza;
          this.images = res.objectImages;
          this.thumbnails = res.objectImages.map(img => ({
            ...img,
            imageUrl: img.imageUrl.includes('?') 
              ? img.imageUrl + '&type=thumbnail'
              : img.imageUrl + '?type=thumbnail'
          }));
          this.rows = this.objectService.getRows(res);
          const hebrewValues = this.rows?.tenthRow.licencesValue.map(item => item.hebrew).join(', ');
          const englishValues = this.rows?.tenthRow.licencesValue.map(item => item.english).join(', ');
          if (hebrewValues && englishValues) {
            this.licencesValue = new MultiLangStrDto(hebrewValues, englishValues);
          }
          this.objectLoading = false;
        },
        error: () => {
          this.objectLoading = false;
        },
        complete: () => {
          this.objectLoading = false;
        }
      });
  }

  handleClickHachraza($event:any){
    this.menuItemsService.setLastFocusedElement($event);
    this.gaService.trackWithGA('hachraza', 'entityType')
    this.routingService.navigateWithMerge({ entityId: this.entityIdHachraza, entityType:"hachraza" }, ['']);
  }
}
